import React from "react";
import "../App.css";
import { Row, Col, Layout, Layout as AntdLayout } from "antd";
import "antd/dist/antd.css";
import styled from "@emotion/styled";
import Footer from "../components/Footer";
import Header from "../components/Header";
import one from "../assets/1.jpg";
import two from "../assets/2.jpg";
import three from "../assets/3.jpg";
import four from "../assets/4.jpg";
import five from "../assets/5.jpg";
import six from "../assets/6.jpg";
import seven from "../assets/7.jpg";
import eight from "../assets/8.jpg";
import nine from "../assets/9.jpg";
import ten from "../assets/10.jpg";
import eleven from "../assets/11.jpg";
import twelve from "../assets/12.jpg";

const CustomContent = styled(AntdLayout.Content)({
  backgroundColor: "lightyellow",
  color: "lightblack",
  textAlign: "left",
  paddingLeft:"5%",
  paddingRight:"5%",
  paddingTop: "3%",
  "@media (max-width: 992px)": {
    paddingTop: "5%",
  },
  "@media (max-width: 768px)": {
    paddingTop: "6%",
  },
  "@media (max-width: 576px)": {
    paddingTop: "6%",
  },
  "@media (max-width: 480px)": {
    paddingTop: "8%",
  },
});
const Maintext = styled(AntdLayout.Content)({
  backgroundColor: "transparent",
  fontColor: "lightblack",
  textAlign: "left",
  fontSize: "26px",
  fontWeight: "bold",
  "@media (max-width: 992px)": {
    paddingLeft: "6%",
  },
  "@media (max-width: 768px)": {
    paddingLeft: "7%",
  },
  "@media (max-width: 576px)": {
    paddingLeft: "8%",
  },
  "@media (max-width: 480px)": {
    paddingLeft: "8%",
  },
});
const Export: React.FC = (): JSX.Element => (
  <Layout>
    <Header />
    <CustomContent style={{ textAlign: "center" }}>
      <Maintext>Galerija</Maintext>
      <br/>
      <Row>
        <Col xs={24} sm={12} md={12} lg={8} xl={8}>
          <img
            src={one}
            style={{ blockSize: "220px", padding: "5px" }}
            className="one"
            alt="logo"
          />
        </Col>
        <Col xs={24} sm={12} md={12} lg={8} xl={8}>
          <img
            src={two}
            style={{ blockSize: "220px", padding: "5px" }}
            className="two"
            alt="logo"
          />{" "}
        </Col>
        <Col xs={24} sm={12} md={12} lg={8} xl={8}>
          <img
            src={three}
            style={{ blockSize: "220px", padding: "5px" }}
            className="three"
            alt="logo"
          />
        </Col>
        <br></br>
        <Col xs={24} sm={12} md={12} lg={8} xl={8}>
          <img
            style={{ blockSize: "220px", padding: "5px" }}
            src={four}
            className="four"
            alt="logo"
          />
        </Col>
        <Col xs={24} sm={12} md={12} lg={8} xl={8}>
          <img
            src={five}
            style={{ blockSize: "220px", padding: "5px" }}
            className="five"
            alt="logo"
          />
        </Col>
        <Col xs={24} sm={12} md={12} lg={8} xl={8}>
          <img
            src={six}
            style={{ blockSize: "220px", padding: "5px" }}
            className="six"
            alt="logo"
          />
        </Col>
        <br></br>
        <Col xs={24} sm={12} md={12} lg={8} xl={8}>
          <img
            src={seven}
            style={{ blockSize: "220px", padding: "5px" }}
            className="seven"
            alt="logo"
          />
        </Col>
        <Col xs={24} sm={12} md={12} lg={8} xl={8}>
          <img
            src={eight}
            style={{ blockSize: "220px", padding: "5px" }}
            className="eight"
            alt="logo"
          />
        </Col>
        <Col xs={24} sm={12} md={12} lg={8} xl={8}>
          <img
            src={nine}
            style={{ blockSize: "220px", padding: "5px" }}
            className="nine"
            alt="logo"
          />
        </Col>
        <br></br>
        <Col xs={24} sm={12} md={12} lg={8} xl={8}>
          <img
            src={ten}
            style={{ blockSize: "220px", padding: "5px" }}
            className="ten"
            alt="logo"
          />
        </Col>
        <Col xs={24} sm={12} md={12} lg={8} xl={8}>
          <img
            src={eleven}
            style={{ blockSize: "220px", padding: "5px" }}
            className="eleven"
            alt="logo"
          />
        </Col>
        <Col xs={24} sm={12} md={12} lg={8} xl={8}>
          <img
            src={twelve}
            style={{ blockSize: "220px", padding: "5px" }}
            className="twelve"
            alt="logo"
          />
        </Col>
      </Row>
      <br/>
    </CustomContent>
    <Footer />
  </Layout>
);

export default Export;
